import { HashRouter } from 'react-router-dom';

import { I18nProvider } from '@/providers/i18n';
import ErrorBoundary from '@/ui/ErrorBoundary';

import AppRoutes from './routes';

export default function App() {
  return (
    <ErrorBoundary>
      <I18nProvider>
        <HashRouter>
          <AppRoutes />
        </HashRouter>
      </I18nProvider>
    </ErrorBoundary>
  );
}
